// extracted by mini-css-extract-plugin
export default {"Footer":"Footer_Footer__08-Dq","Left":"Footer_Left__4VnYD","Center":"Footer_Center__6SLuE","Right":"Footer_Right__424nw"};